import { render, staticRenderFns } from "./evaluationsOnClients.vue?vue&type=template&id=24d2eec2&scoped=true&"
import script from "./evaluationsOnClients.vue?vue&type=script&lang=js&"
export * from "./evaluationsOnClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d2eec2",
  null
  
)

export default component.exports